import axios from "@/plugins/axios";

export const state = () => ({
  sales: [],
  customerSales: [],
  sales_info: {},
  customer_cash_pending_sales: [],
});

export const mutations = {
  SET_SALES(state, payload) {
    state.sales = payload;
  },
  SET_CUSTOMER_SALES(state, payload) {
    state.customerSales = payload;
  },
  SET_SALE_INFO(state, payload) {
    state.sales_info = payload;
  },
  SET_CUSTOMER_CASH_PENDING_SALES(state, payload) {
    state.customer_cash_pending_sales = payload;
  },
};

export const actions = {
  async fetchSales({ commit }, payload = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get("pos/sales/all", payload)
        .then((res) => {
          commit("SET_SALES", res.data.data);
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  async fetchSalesInfo({ commit }, payload = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get("pos/sales/" + payload.id)
        .then((res) => {
          commit("SET_SALE_INFO", res.data);

          // resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  async fetchCustomerSales({ commit }, payload = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get("pos/sales/all-sales", payload)
        .then((res) => {
          commit("SET_CUSTOMER_SALES", res.data.data);
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  async fetchCustomerCashPendingSales(
    { state, commit, getters },
    payload = {}
  ) {
    return new Promise((resolve, reject) => {
      axios
        .get(`pos/customers/${payload}/sales-credit-details`)
        .then((res) => {
          commit("SET_CUSTOMER_CASH_PENDING_SALES", res.data);
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export const getters = {
  GetSalesInfo(state) {
    return state.sales_info;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
